'use strict';

module.exports = /(\w{3})[()\s\d]*$/;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/var/TIMEZONE_ABBREVIATION_REG.js
// module id = 273
// module chunks = 0